import { useEffect, useState } from "react";
import { getUserCountry, hasDiscount } from "../../../utils/utils";
import ReactMarkdown from "react-markdown";

interface PackageCardProps {
    packages: {
        id: string;
        name: string;
        description: string;
        actualPrice_egp: string;
        actualPrice_usd: string;
        discountPrice_usd:string;
        img_url:string;
        discountPrice_egp:string;
        courses: {
            id: string;
            name: string;
            img_url: string;
            actualPrice_egp: string;
            actualPrice_usd: string;
        }[];
    };
}

const PackageCard = ({ packages }: PackageCardProps) => {
    const [country, setCountry] = useState<string | null>(null);

    useEffect(() => {
        const userCountry = getUserCountry();
        setCountry(userCountry);
    }, []);

    return (
        <div className="group relative flex w-full flex-col justify-between overflow-visible rounded-2xl border border-black/10 bg-white p-4 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_55px_rgba(17,24,22,0.12)]">
            <div className="relative mb-4 w-full">
            <img
                                src={packages.img_url}
                                className='aspect-[4/3] w-full rounded-xl object-cover transition duration-300 group-hover:scale-[1.015]'
                            />
            {country === 'EG' ? (
                    <>
                        {hasDiscount(packages.actualPrice_egp, packages.discountPrice_egp) && (
                            <div className="absolute bottom-6 right-1 flex h-7 items-center justify-center rounded-l-xl border border-red-200 bg-white px-2 text-sm font-semibold text-red-600 line-through shadow-sm md:text-base">
                                {packages.actualPrice_egp} EGP
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {hasDiscount(packages.actualPrice_usd, packages.discountPrice_usd) && (
                            <div className="absolute bottom-6 right-1 flex h-7 items-center justify-center rounded-l-xl border border-red-200 bg-white px-2 text-sm font-semibold text-red-600 line-through shadow-sm md:text-base">
                                {packages.actualPrice_usd} USD
                            </div>
                        )}
                    </>
                )}
            </div>

            <div>
                <div className="flex justify-between w-full items-center mb-3 py-0.5">
                    <h1 className="min-w-0 text-xl font-bold text-textPrimary">{packages.name}</h1>

                    <div className="flex min-w-[90px] items-center justify-center gap-0.5 rounded-xl bg-primary px-3 py-1.5 font-bold text-white">
                        {country === "EG" ? (
                            <>
                                {hasDiscount(packages.actualPrice_egp, packages.discountPrice_egp)
                                    ? packages.discountPrice_egp
                                    : packages.actualPrice_egp}{" "}
                                <span className="text-sm uppercase">EGP</span>
                            </>
                        ) : (
                            <>
                                {hasDiscount(packages.actualPrice_usd, packages.discountPrice_usd)
                                    ? packages.discountPrice_usd
                                    : packages.actualPrice_usd}{" "}
                                <span className="text-sm uppercase">USD</span>
                            </>
                        )}
                    </div>
                </div>
                <div className=" mb-4">
                    <span className="text-sm font-medium text-lightGray">
                        <ReactMarkdown>{packages.description}</ReactMarkdown>
                    </span>
                </div>

            </div>
        </div>
    );
};

export default PackageCard;
